// Copyright (c) 2017 Deere & Company

import t from 'tcomb';

const WipReturnParts = t.struct({
    partsToReturn: t.Number
}, {
    name: 'WipReturnParts',
    strict: true
});

export const getDefaultState = () => new WipReturnParts({
    partsToReturn: 0
});

export default WipReturnParts;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/wip-return-parts.js